/** Clamps `targetWidth` to the range input's `min`/`max` bounds (when finite/positive). */
export const clampToInputBounds = (input: HTMLInputElement, targetWidth: number): number => {
	const min = Number(input.min);
	const max = Number(input.max);

	let clamped = targetWidth;
	if (Number.isFinite(min)) {
		clamped = Math.max(clamped, min);
	}
	if (Number.isFinite(max) && max > 0) {
		clamped = Math.min(clamped, max);
	}
	return clamped;
};
